import { useHamburguer, UseHamburguerProps } from "./use-hamburguer";

export type HamburguerProps = UseHamburguerProps;

export const Hamburguer = (props: HamburguerProps) => {
  const { className, styles, active, toggle, ariaLabel, ariaControls } =
    useHamburguer(props);

  return (
    <button
      className={styles.base({ className })}
      type="button"
      aria-label={ariaLabel}
      aria-controls={ariaControls}
      aria-expanded={active}
      onClick={toggle}
    >
      <i aria-hidden="true" className={styles.bar()} />
    </button>
  );
};
